import classNames from "classnames";
import {
  ForwardedRef,
  TextareaHTMLAttributes,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import useFieldFeedback from "./../useFieldFeedback";
import "./../InputTextElement.css";
import "./../../common.css";

export type TextareaHandle = {
  focus: () => void;
  clearState: () => void;
  isInvalid: () => boolean;
};

type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "ref"> & {
  formSubmitted?: boolean;
  rtl?: boolean;
};

function Textarea(props: TextareaProps, ref: ForwardedRef<TextareaHandle>) {
  const { formSubmitted, rtl, className, ...rest } = props;
  const elementRef = useRef<HTMLTextAreaElement>(null);
  const feedback = useFieldFeedback<HTMLTextAreaElement>({ ...rest, formSubmitted });

  useImperativeHandle(ref, () => ({
    focus: () => elementRef.current?.focus(),
    clearState: feedback.clearState,
    isInvalid: feedback.isInvalid,
  }));

  return (
    <div className="input-container">
      <textarea
        {...rest}
        ref={elementRef}
        className={classNames(className, "talaera-textarea", feedback.stateClass)}
        dir={rtl ? "rtl" : undefined}
        {...feedback.handlers}
      />
      {feedback.tooltip && (
        <span className={classNames("input-tooltip", feedback.stateClass)}>
          {feedback.tooltip}
        </span>
      )}
    </div>
  );
}

export default forwardRef(Textarea);
